"use strict";

var _slicedToArray = require("/media/konapun/Data/Programming/projects/konapun.github.io/node_modules/@babel/runtime/helpers/slicedToArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("source-map-support/register");

var _lifecycle = require("../lifecycle");

var _error = require("../error");

var loadOne = function loadOne(plugin) {
  Object.entries(plugin).forEach(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        pluginPhase = _ref2[0],
        actionDefinition = _ref2[1];

    if (!(pluginPhase in _lifecycle.phase)) {
      throw new _error.ValidationError("Can't register plugin action for key \"".concat(pluginPhase, "\" (available keys are ").concat(Object.keys(_lifecycle.phase).join(' '), ")"));
    }

    _lifecycle.phase[pluginPhase].extend(actionDefinition);
  });
};

var pluginService = function pluginService() {
  return function (services) {
    return {
      load: function load(plugins) {
        [].concat(plugins).map(function (pluginDefinition) {
          return pluginDefinition(services);
        }).forEach(function (plugin) {
          return loadOne(plugin);
        });
      }
    };
  };
};

var _default = pluginService;
exports.default = _default;